import React from 'react';

/**
 * Loading
 */
class Loading extends React.Component {

  render() {
    return (
      <div id="loading">
        <img src="/img/loading_s.gif" alt="Loading…" />
      </div>
    );
  }
}

export default Loading;
